import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import FoodView from '@/views/Food/FoodView.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import FoodRecommend from '@/views/Food/FoodRecommend.vue';
import FoodPromotion from '@/views/Food/FoodPromotion.vue';
import FoodSales from '@/views/Food/FoodSales.vue';
import FoodDiscount from '@/views/Food/FoodDiscount.vue';
import FoodShopLove from '@/views/Food/FoodShopLove.vue';
import FoodProDD from '@/views/Food/FoodProDD.vue';
import HotelView from '@/views/Hotel/HotelView.vue';
import HotelAds from '@/views/Hotel/HotelAds.vue';
import HotelRoom from '@/views/Hotel/HotelRoom.vue';
import HomeArtworkView from '@/views/HomeArtworkView.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'HomeArtwork',
    component: HomeArtworkView,
    meta: {
      open: true,
    },
  },
  {
    path: '/food',
    name: 'FoodView',
    component: DefaultLayout,
    meta: {
      open: true,
    },
    children: [
      {
        path: '/',
        name: 'Food',
        component: FoodView,
        meta: {
          open: true,
        },
      },
      {
        path: '/food/recommend',
        name: 'FoodRecommend',
        props: {
          headTitle: 'รูปแนะนำร้านค้า',
        },
        component: FoodRecommend,
        meta: {
          open: true,
        },
      },
      {
        path: '/food/promotion',
        name: 'FoodPromotion',
        props: {
          headTitle: 'รูปโปรโมชันแถม',
        },
        component: FoodPromotion,
        meta: {
          open: true,
        },
      },
      {
        path: '/food/sales',
        name: 'FoodSales',
        props: {
          headTitle: 'รูปลดราคาทุกเมนู',
        },
        component: FoodSales,
        meta: {
          open: true,
        },
      },
      {
        path: '/food/discount',
        name: 'FoodDiscount',
        props: {
          headTitle: 'รูปลดราคาเฉพาะเมนู',
        },
        component: FoodDiscount,
        meta: {
          open: true,
        },
      },
      {
        path: '/food/shoplove',
        name: 'FoodShopLove',
        props: {
          headTitle: 'รูปร้านเล็กที่คุณรัก',
        },
        component: FoodShopLove,
        meta: {
          open: true,
        },
      },
      {
        path: '/food/prodd',
        name: 'FoodProDD',
        props: {
          headTitle: 'ส่วนลดดีดี',
        },
        component: FoodProDD,
        meta: {
          open: true,
        },
      },
    ],
  },
  {
    path: '/hotel',
    name: 'HotelView',
    component: DefaultLayout,
    meta: {
      open: true,
    },
    children: [
      {
        path: '/',
        name: 'Hotel',
        component: HotelView,
        meta: {
          open: true,
        },
      },
      {
        path: '/hotel/ads',
        name: 'HotelAds',
        props: {
          headTitle: 'รูปโฆษณา',
        },
        component: HotelAds,
        meta: {
          open: true,
        },
      },
      {
        path: '/hotel/room',
        name: 'HotelRoom',
        props: {
          headTitle: 'รูปห้อง',
        },
        component: HotelRoom,
        meta: {
          open: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.open) {
    return next();
  }

  return next('/');
});

export default router;
